<template>
  <IntegrationWorkflowWrapper
    v-model:is-enabled="isAccountObjectPushEnabled"
    title="Push to Account Object"
    description="Push partner overlap data into Salesforce’s standard Account object. This makes it available across the workflows, reports, dashboards, and processes your revenue team already uses every day."
  >
    <!-- TODO: workflow status will live here -->
    <AccountObjectFields v-if="integrationProfileType === 'salesforce'" />
  </IntegrationWorkflowWrapper>
  <PartnerFieldMappings
    v-model:is-enabled="isPartnerFieldsPushEnabled"
    :integration-profile-type="integrationProfileType"
  />
</template>

<script setup lang="ts">
import { IntegrationProfileType } from '@/types/integration_profiles';

import AccountObjectFields from './AccountObjectFields.vue';
import IntegrationWorkflowWrapper from './IntegrationWorkflowWrapper.vue';
import PartnerFieldMappings from './PartnerFieldMappings.vue';

const { integrationProfileType } = defineProps<{
  integrationProfileType: IntegrationProfileType | undefined;
}>();

const isAccountObjectPushEnabled = defineModel<boolean>(
  'isAccountObjectPushEnabled',
);
const isPartnerFieldsPushEnabled = defineModel<boolean>(
  'isPartnerFieldsPushEnabled',
);
</script>
